/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Common pagination metadata used by search endpoints.
 * @export
 * @interface APIPagination
 */
export interface APIPagination {
    /**
     * 
     * @type {number}
     * @memberof APIPagination
     */
    fromValue: number;
    /**
     * 
     * @type {number}
     * @memberof APIPagination
     */
    size: number;
    /**
     * 
     * @type {boolean}
     * @memberof APIPagination
     */
    hasMore: boolean;
}

/**
 * Check if a given object implements the APIPagination interface.
 */
export function instanceOfAPIPagination(value: object): value is APIPagination {
    if (!('fromValue' in value) || value['fromValue'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('hasMore' in value) || value['hasMore'] === undefined) return false;
    return true;
}

export function APIPaginationFromJSON(json: any): APIPagination {
    return APIPaginationFromJSONTyped(json, false);
}

export function APIPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPagination {
    if (json == null) {
        return json;
    }
    return {
        
        'fromValue': json['from_value'],
        'size': json['size'],
        'hasMore': json['has_more'],
    };
}

export function APIPaginationToJSON(value?: APIPagination | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'from_value': value['fromValue'],
        'size': value['size'],
        'has_more': value['hasMore'],
    };
}

